// ========================================
// CONFIGURACIÓN DEL FRONTEND
// Variables de entorno y configuración de la aplicación
// ========================================

const config = {
  // URLs de la API
  API_URL: process.env.REACT_APP_API_URL || 'https://reservaauditorios.usbcali.edu.co/api',
  API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
  API_RETRY_ATTEMPTS: parseInt(process.env.REACT_APP_API_RETRY_ATTEMPTS) || 3,

  // Endpoints de la API
  ENDPOINTS: {
    LOGIN: process.env.REACT_APP_LOGIN_ENDPOINT || '/login',
    RESERVA: process.env.REACT_APP_RESERVA_ENDPOINT || '/reservar-auditorio',
    RESERVAS: process.env.REACT_APP_RESERVAS_ENDPOINT || '/reservas',
    TEST_LDAP: process.env.REACT_APP_TEST_LDAP_ENDPOINT || '/test-ldap',
    CONFIG: '/config',
    CHECK_ADMIN: '/check-admin',
    // Endpoints de administración
    ADMIN_RESERVAS: '/admin/reservas',
    ADMIN_USUARIOS: '/admin/usuarios'
  },

  // Configuración de la aplicación
  APP_NAME: process.env.REACT_APP_NAME || 'Sistema de Reserva de Auditorios',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  APP_DESCRIPTION: process.env.REACT_APP_DESCRIPTION || 'Sistema para gestión de reservas de auditorios universitarios',

  // Configuración del captcha
  CAPTCHA: {
    LENGTH: parseInt(process.env.REACT_APP_CAPTCHA_LENGTH) || 6,
    REFRESH_INTERVAL: parseInt(process.env.REACT_APP_CAPTCHA_REFRESH_INTERVAL) || 30000
  },

  // Configuración de imágenes
  IMAGES: {
    BACKGROUND: process.env.REACT_APP_BACKGROUND_IMAGE || '/imagenes/fondo.jpg',
    LOGO: process.env.REACT_APP_LOGO_IMAGE || '/imagenes/logo2.jpg'
  },

  // Configuración de auditorios
  AUDITORIOS: [
    { id: 'aud1', nombre: 'Auditorio Principal', capacidad: 200, ubicacion: 'Edificio A - Piso 1' },
    { id: 'aud2', nombre: 'Sala de Conferencias', capacidad: 50, ubicacion: 'Edificio B - Piso 2' },
    { id: 'aud3', nombre: 'Aula Magna', capacidad: 150, ubicacion: 'Edificio C - Piso 1' },
    { id: 'aud4', nombre: 'Sala de Reuniones', capacidad: 30, ubicacion: 'Edificio A - Piso 3' }
  ],

  // Equipos disponibles
  EQUIPOS_DISPONIBLES: [
    'Proyector',
    'Sistema de Sonido',
    'Micrófono - Expositor',
    'Micrófono - Pedestal',
    'Micrófono - Auxiliar',
    'Camara Web - Fija',
    'Camara Web - Movil',
  ],

// Opcionales Disponibles
  OPCIONALES_DISPONIBLES: [
    'Auditorio - Plano',
    'Auditorio - Escalonado',
    'Mobiliario - Fijo',
    'Mobiliario - Móvil',
    'Usuarios Movilidad Reducida',
  ],

  // Configuración de validaciones
  VALIDACIONES: {
    MIN_HORAS_ANTICIPACION: 6, // Horas mínimas para reservar
    MAX_DURACION_RESERVA: 8,    // Horas máximas por reserva
    MAX_RESERVAS_USUARIO: 5     // Máximo de reservas activas por usuario
  },

  // Configuración de mensajes
  MENSAJES: {
    ERROR_CONEXION: 'Error de conexión con el servidor',
    ERROR_AUTENTICACION: 'Error de autenticación',
    LOGIN_EXITOSO: '¡Login exitoso! Redirigiendo...',
    RESERVA_EXITOSA: '¡Reserva realizada exitosamente!',
    CAPTCHA_INCORRECTO: 'Captcha incorrecto. Intenta de nuevo.',
    CAMPOS_INCOMPLETOS: 'Por favor completa todos los campos obligatorios.',
    HORARIO_INVALIDO: 'La hora de inicio debe ser anterior a la hora de fin.',
    FECHA_PASADA: 'No se pueden hacer reservas en fechas pasadas.',
    HORA_PASADA: 'No se pueden hacer reservas en horas pasadas.',
    CONFLICTO_HORARIO: 'El auditorio ya está reservado en ese horario.'
  },

  // Configuración de estilos
  ESTILOS: {
    COLORS: {
      PRIMARY: '#EF7D00',
      SECONDARY: '#EF630F',
      ACCENT: '#FFAB1B',
      DARK: '#1D1D1B',
      LIGHT: '#FFFFFF',
      GRAY_DARK: '#333333',
      GRAY_MEDIUM: '#808080',
      GRAY_LIGHT: '#CCCCCC'
    },
    ANIMATIONS: {
      DURATION: '0.3s',
      EASING: 'ease'
    }
  },

  // Configuración de desarrollo
  DEVELOPMENT: {
    SHOW_CONFIG_ENDPOINT: process.env.NODE_ENV === 'development',
    LOG_REQUESTS: process.env.NODE_ENV === 'development',
    MOCK_DATA: process.env.NODE_ENV === 'development'
  }
};

// Función para obtener la URL completa de un endpoint
export const getApiUrl = (endpoint) => {
  return `${config.API_URL}${endpoint}`;
};

// Función para validar si estamos en desarrollo
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

// Función para obtener la configuración completa
export const getConfig = () => {
  return config;
};

// Función para obtener un valor específico de configuración
export const getConfigValue = (key, defaultValue = null) => {
  const keys = key.split('.');
  let value = config;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return defaultValue;
    }
  }
  
  return value;
};

export default config;

